import { isBefore, parseISO, subDays } from 'date-fns';

export default function isDueDate(dateString) {
  const date = parseISO(dateString);
  const nowMinus30days = subDays(new Date(), 30);
  return isBefore(date, nowMinus30days);
}
